import React from "react"

class DownloadLauncher extends React.Component{
    downloadLauncher = () =>{
        window.open(`https://arcade-launcher-installer.s3-us-west-1.amazonaws.com/installer_release.exe`, "_self")
    }
    render(){
        return(
            <div className="mainContent">
                <div className="downloadLauncher">
                    <h1>Download launcher to play games in the arcade!</h1>
                    <button className="downloadBtn" onClick={this.downloadLauncher}>
                        Download!
                    </button>
                </div>
            </div>
        )
    }
}

export default DownloadLauncher